import React from 'react'
import classes from "./ActiveInactive.module.css"
import clsx from 'clsx'
const ActiveInactive = ({active}) => {
  return (
    <span className={classes.wrapper}>
        <span className={clsx(classes.ball,{
            [classes.active]:active,
            [classes.inactive]:!active
        })}></span>
        <span className={classes.title}>{active ? "Active" : "Inactive"}</span>
    </span>
  )
}

export default ActiveInactive